export default __webpack_public_path__ + "static/media/Screenshot_5.d658c606.png";